import { Role } from './../user.model';
import { Itinerary, Status } from "./../itineray.model";
import { Component, Input, EventEmitter, Output } from "@angular/core";
import { DaysBetweenPipe } from '../days-between.pipe';

@Component({
  selector: "app-itinerary-list-item",
  templateUrl: "./itinerary-list-item.component.html",
  styleUrls: ["./itinerary-list-item.component.css"]
})
export class ItineraryListItemComponent {
  @Input()
  itinerary: Itinerary;

  @Input()
  userRole: Role;

  @Output()
  archiveClicked = new EventEmitter<void>();

  @Output()
  unarchiveClicked = new EventEmitter<void>();

  @Output()
  deleteClicked = new EventEmitter<void>();

  private now = new Date();

  constructor(private daysBetweenPipe: DaysBetweenPipe) {

  }

  getElapsedDays(itinerary: Itinerary) {
    if (itinerary.createdAt) {
      return this.daysBetweenPipe.transform({ start: itinerary.createdAt.toDate(), end: this.now }) - 1;
    }
  }

  isClickable() {
    return this.userRole === Role.CUSTOMER ? this.itinerary.status === Status.DONE : true;
  }

  onClick() {
    if (!this.isClickable()) {
      alert("Questo itinerario è ancora in fase di realizzazione. Riceverai una mail quando sarà pronto.");
    }
  }

  onArchiveClick() {
    this.archiveClicked.emit();
  }

  onUnarchiveClick() {
    this.unarchiveClicked.emit();
  }

  onDeleteClick() {
    this.deleteClicked.emit();
  }

}
